export interface Bonus {
  title: string
  description: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'No-Equipment PE',
    description: '50 ready-to-use activities for classes without specialist equipment.',
    image: 'https://cdn.magicpatterns.com/uploads/pUbgPq5hVbyoHMkdkfXkuT/pe1.webp',
  },
  {
    title: 'PE Station Cards',
    description: '40 print-and-go challenges plus ready-made station circuits.',
    image: 'https://cdn.magicpatterns.com/uploads/aBQcbSYYjRmouDKma3JeFS/pe_2.webp',
  },
  {
    title: 'Class Management Toolkit',
    description: 'Practical routines, signals, transitions, checklists, and teacher scripts.',
    image: 'https://cdn.magicpatterns.com/uploads/qxzMt37JYjhazYS3nsNKun/pe_3.webp',
  },
  {
    title: 'Inclusive PE Adaptation Cards',
    description: '36 practical ways to adapt space, equipment, rules, time, communication, and grouping.',
    image: 'https://cdn.magicpatterns.com/uploads/6wBAPbf8EySHRZFwRDEMhf/p4.webp',
  },
  {
    title: 'PE Games for Any Space',
    description: '30 flexible games for gyms, classrooms, playgrounds, and outdoor areas.',
    image: 'https://cdn.magicpatterns.com/uploads/vZMRyhHU7fWhVfEYJX22f9/p5.webp',
  },
]
